module.exports = __webpack_public_path__ + "assets/img/8_1344_big.77a69fb2.jpg";